"use strict";

($dt => {

	const controller = {
		on_success_events: [],

		RegisterOnSuccessEvent: on_success => {
			controller.on_success_events.push(on_success);
		},

		Init: () => {
			$dt.OnDevelformsReady($df => {
				$df.RegisterFormPreparedEvent('wplogin', form => {
					form.success = resp => {
						// Transitions form using default simple methods
						form.simpleSuccess(resp);

						// Fire registered success events
						controller.on_success_events.forEach(ev => {
							ev();
						});

						// Redirect
						if (resp.redirect) {
							setTimeout(() => {
								window.location.href = resp.redirect;
							}, 2500);
						}
					};
				});
			});
		}
	};

	$dt.forms.Login = controller;
	$dt.autostart.push(controller.Init);

})(window.d3_wp_themejs);
